module.exports = __webpack_public_path__ + "img/nlikes.a38a6cb6.svg";